import React, { useEffect } from "react";
import Layout from "./layout";
import useApiPost from "../../Hooks/usePost";
import { LOCAL_API_URL } from "../../path";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

const Login = () => {
  const Navigate = useNavigate();

  const LoginApi = useApiPost(`${LOCAL_API_URL}login`);

  const LoginSubmit = (email, password) => {
    LoginApi.postData({
      email_id: email,
      password,
    });
  };

  useEffect(() => {
    if (LoginApi.data !== null) {
      if (LoginApi.data?.status === 200) {
        message.success({
          type: "success",
          content: `Login successfully`,
        });

        // Save login token
        localStorage.setItem(
          "SDG_TOKEN",
          LoginApi.data?.body?.token
        );

        // Get college ID from login response
        const collegeId = LoginApi.data?.body?.college_id;

        // Save college ID
        localStorage.setItem(
          "SDG_COLLEGE_ID",
          String(collegeId)
        );

        // M.O.P. Vaishnav College for Women
        if (String(collegeId) === "1") {
          Navigate(`/college/1/${new Date().getFullYear()}`, {
            replace: true,
          });
        } else {
          // Normal users
          Navigate("/", {
            replace: true,
          });
        }
      } else {
        message.error({
          type: "warning",
          content: `Invalid email and password`,
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LoginApi.data]);

  return (
    <div className="w-full h-full">
      <Layout
        LoginSubmit={LoginSubmit}
        LoginApi={LoginApi}
      />
    </div>
  );
};

export default Login;